"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HierarchyUtil_1 = require("../util/HierarchyUtil");
var types_1 = require("../types");
var PersonHierarchyUtil_1 = __importDefault(require("./PersonHierarchyUtil"));
var Constants_1 = require("../Constants");
var NonMgrHierarchyUtil = /** @class */ (function (_super) {
    __extends(NonMgrHierarchyUtil, _super);
    function NonMgrHierarchyUtil() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.canViewNodeName = true;
        _this.labels = {
            breakdownNameLabel: 'Employee Breakdown',
            summaryBreakdownToolTip: 'When you have multiple level one nodes information displayed is for the largest node.',
            nodeNameLabel: 'Title',
            nodeExternalIdLabel: 'Position Id',
            nodeDataExternalIdLabel: 'Employee Id',
            nodeDataNameLabel: 'Full Name',
            parentNodeDataNameLabel: 'Manager Name',
            childNodeCountLabel: 'Direct Reports',
        };
        return _this;
    }
    NonMgrHierarchyUtil.prototype.getNodeDisplayName = function (params) {
        var nodeVm = params.nodeVm, hierarchyEditState = params.hierarchyEditState;
        return this.nodeDisplayName(nodeVm, hierarchyEditState, function (nodeName, personName) {
            switch (nodeVm.nodeType) {
                case types_1.NodeType.Person:
                    return personName;
                case types_1.NodeType.Location:
                default:
                    return nodeName || 'No Value';
            }
        });
    };
    NonMgrHierarchyUtil.prototype.showPeopleToggle = function (node) {
        return node.nodeType === types_1.NodeType.Location;
    };
    NonMgrHierarchyUtil.prototype.disablePeopleToggle = function (node) {
        return node.editState === types_1.NodeMoveState.Move;
    };
    NonMgrHierarchyUtil.prototype.indentNodeAtLevel = function (node) {
        return node.nodeType !== types_1.NodeType.Person || !!node.isOrphan;
    };
    NonMgrHierarchyUtil.prototype.getNodeMoveType = function (sourceType, nodeMoveState, replaceDestination, destinationIsOrphan) {
        if (destinationIsOrphan) {
            return types_1.NodeMoveType.MoveToUnparented;
        }
        if (sourceType === types_1.NodeType.Location) {
            return types_1.NodeMoveType.MoveLocationNode;
        }
        return types_1.NodeMoveType.MoveNodeUnder;
    };
    NonMgrHierarchyUtil.prototype.movingNodes = function (nodes, hierarchyEditState) {
        var _a, _b;
        if (!(0, HierarchyUtil_1.isMovingNodes)(hierarchyEditState)) {
            return [];
        }
        var node = nodes[hierarchyEditState.selectedNodeId];
        if (node.nodeType !== types_1.NodeType.Location) {
            return [node];
        }
        return (_b = (_a = node.belongsToNodeIds) === null || _a === void 0 ? void 0 : _a.map(function (id) { return nodes[id]; })) !== null && _b !== void 0 ? _b : [];
    };
    NonMgrHierarchyUtil.prototype.isValidMoveDestination = function (node, moving, parentIds) {
        if (!_super.prototype.isValidMoveDestination.call(this, node, moving, parentIds)) {
            return false;
        }
        if (node.nodeId === Constants_1.Constants.ORPHAN_PLACEHOLDER_ID) {
            return true;
        }
        if (node.nodeType === types_1.NodeType.Location && !this.isPlaceholderLocation(node)) {
            if (moving.nodeType === types_1.NodeType.Person) {
                var movedFromLocation = parentIds[moving.nodeId];
                // Ensure that the dest selected is not the original location that the employee was moved from.
                return movedFromLocation !== node.nodeId;
            }
            return true;
        }
        return false;
    };
    NonMgrHierarchyUtil.prototype.getDescendantNodeCount = function (nodeVm, structureOnlyHierarchy) {
        var count = structureOnlyHierarchy ? 1 : 0; // 1 because node metrics dont count the current node
        if (structureOnlyHierarchy) {
            count += nodeVm.totalNodes !== undefined ? nodeVm.totalNodes : 0;
        }
        else {
            count += nodeVm.totalRollups !== undefined ? nodeVm.totalRollups : 0;
        }
        return count;
    };
    NonMgrHierarchyUtil.prototype.getSingleNodeCount = function (nodeVm, structureOnlyHierarchy) {
        var count = structureOnlyHierarchy ? 1 : 0;
        if (!structureOnlyHierarchy) {
            count += nodeVm.directEmployeeCount !== undefined ? nodeVm.directEmployeeCount : 0;
        }
        return count;
    };
    NonMgrHierarchyUtil.prototype.isLeafNode = function (nodeVm) {
        return !nodeVm.totalNodes;
    };
    NonMgrHierarchyUtil.prototype.isOpenNode = function (nodeVm) {
        return _super.prototype.isOpenNode.call(this, nodeVm) && nodeVm.nodeType === types_1.NodeType.Person;
    };
    NonMgrHierarchyUtil.prototype.isPlaceholderLocation = function (node) {
        return node.nodeType === types_1.NodeType.Location && !node.name;
    };
    return NonMgrHierarchyUtil;
}(PersonHierarchyUtil_1.default));
exports.default = NonMgrHierarchyUtil;
